import React from 'react'

import clsx from 'clsx'

function ToggleSwitch(props, ref) {
    const {
        onChange,
        checked,
        defaultChecked,
        disabled,
        label,
        id,
        ...rest
    } = props

    return <label
        className={clsx("switch", props.className, {
            "switch-disabled": disabled,
            "has-text": label !== "" && label,
            "tooltip-bottom": props.tooltip
        })}
        data-tooltip={props.tooltip}
        onClick={(e)=>{
            e.stopPropagation()
        }}
    >
        <input type="checkbox"
           checked={checked}
           defaultChecked={defaultChecked}
           disabled={disabled}
           onChange={() => {
               if(typeof onChange === 'function' && !disabled) onChange()
           }}
           onClick={(e)=>{
               e.stopPropagation()
           }}
           {...rest}
        />
        <span className="slider"/>
        {label !== "" && label ? <span>{label}</span> : null}
    </label>
}

export default React.forwardRef(ToggleSwitch)